<template>































































































































































































































































































































































































































































































































  <div>































































































































































































































































































































































































































































































































    <el-row>































































































































































































































































































































































































































































































































      <el-button































































































































































































































































































































































































































































































































        style="cursor: pointer; width: 10%; float: left; color: white"































































































































































































































































































































































































































































































































        @click="back"































































































































































































































































































































































































































































































































        >返回 稿件列表</el-button































































































































































































































































































































































































































































































































      >































































































































































































































































































































































































































































































































      <el-button































































































































































































































































































































































































































































































































        style="width: 10%; float: right; color: white"































































































































































































































































































































































































































































































































        @click="cancelTheAudit()"































































































































































































































































































































































































































































































































        >撤销审核</el-button































































































































































































































































































































































































































































































































      >































































































































































































































































































































































































































































































































    </el-row>































































































































































































































































































































































































































































































































    <el-row>































































































































































































































































































































































































































































































































      <el-col class="content">































































































































































































































































































































































































































































































































        <div class="mydoc">































































































































































































































































































































































































































































































































          <div class="header" style="font-weight: 900">稿件信息</div>































































































































































































































































































































































































































































































































          <div class="mybody">































































































































































































































































































































































































































































































































            <el-descriptions border :column="1">































































































































































































































































































































































































































































































































              <el-descriptions-item label="稿件标题">































































































































































































































































































































































































































































































































                {{ info.manuscript.title }}































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="稿件编号"































































































































































































































































































































































































































































































































                >SYYYX-{{ time }}</el-descriptions-item































































































































































































































































































































































































































































































































              >































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































              <el-descriptions-item label="摘要">































































































































































































































































































































































































































































































































                <p>{{ info.manuscript.abstracts }}</p></el-descriptions-item































































































































































































































































































































































































































































































































              >































































































































































































































































































































































































































































































































              <el-descriptions-item label="关键词：">































































































































































































































































































































































































































































































































                {{ info.manuscript.manuscriptKeywords }}































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="下载">































































































































































































































































































































































































































































































































                <el-button































































































































































































































































































































































































































































































































                  type="primary"































































































































































































































































































































































































































































































































                  style="background-color: #fd7f48; border: none; color: white"































































































































































































































































































































































































































































































































                  @click="downloadZip(getZipUrl(info.manuscript))"































































































































































































































































































































































































































































































































                  >下载</el-button































































































































































































































































































































































































































































































































                >































































































































































































































































































































































































































































































































                <el-button































































































































































































































































































































































































































































































































                  type="primary"































































































































































































































































































































































































































































































































                  @click="contentShow = true"































































































































































































































































































































































































































































































































                  style="background-color: #fd7f48; border: none; color: white"































































































































































































































































































































































































































































































































                  >点击预览</el-button































































































































































































































































































































































































































































































































                >































































































































































































































































































































































































































































































































                <el-dialog































































































































































































































































































































































































































































































































                  :title="info.manuscript.title"































































































































































































































































































































































































































































































































                  :visible.sync="contentShow"































































































































































































































































































































































































































































































































                  fullscreen































































































































































































































































































































































































































































































































                >































































































































































































































































































































































































































































































































                  <div style="height: 85vh; width: 100%">































































































































































































































































































































































































































































































































                    <iframe































































































































































































































































































































































































































































































































                      :src="































































































































































































































































































































































































































































































































                        'https://www.exp-linguistics.net/file_preview/onlinePreview?url=' +































































































































































































































































































































































































































































































































                        getPdfBase64(info.manuscript)































































































































































































































































































































































































































































































































                      "































































































































































































































































































































































































































































































































                      frameborder="none"































































































































































































































































































































































































































































































































                      width="100%"































































































































































































































































































































































































































































































































                      height="100%"































































































































































































































































































































































































































































































































                    ></iframe>































































































































































































































































































































































































































































































































                  </div>































































































































































































































































































































































































































































































































                </el-dialog>































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="提交日期">































































































































































































































































































































































































































































































































                {{ info.manuscript.deliveryTime.substr(0, 10) }}































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































            </el-descriptions>































































































































































































































































































































































































































































































































          </div>































































































































































































































































































































































































































































































































        </div>































































































































































































































































































































































































































































































































      </el-col>































































































































































































































































































































































































































































































































    </el-row>































































































































































































































































































































































































































































































































    <br />































































































































































































































































































































































































































































































































    <br />































































































































































































































































































































































































































































































































    <el-row class="content">































































































































































































































































































































































































































































































































      <div class="mydoc">































































































































































































































































































































































































































































































































        <div class="header" style="font-weight: 900">稿件审核</div>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































        <div class="mybody">































































































































































































































































































































































































































































































































          <el-col v-if="reviewerManuscriptSatus == 'unreviewed'">































































































































































































































































































































































































































































































































            <div>































































































































































































































































































































































































































































































































              <el-row>































































































































































































































































































































































































































































































































                <el-col :span="24" class="detail">































































































































































































































































































































































































































































































































                  <el-form ref="info" :model="info" label-width="80px">































































































































































































































































































































































































































































































































                    <el-row>































































































































































































































































































































































































































































































































                      <h3>《实验语言学》专家审稿意见表</h3>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                      <el-col :span="22" :offset="2">































































































































































































































































































































































































































































































































                        <p style="text-align: left">































































































































































































































































































































































































































































































































                          1. 恭请您拨冗审阅并将审稿意见发回编辑部。































































































































































































































































































































































































































































































































                        </p>































































































































































































































































































































































































































































































































                        <p style="text-align: left">































































































































































































































































































































































































































































































































                          2.































































































































































































































































































































































































































































































































                          本刊采用双盲审稿，作者姓名与单位暂时保密，请审稿专家勿透露审稿内容。































































































































































































































































































































































































































































































































                        </p>































































































































































































































































































































































































































































































































                        <p style="text-align: left">































































































































































































































































































































































































































































































































                          3. 文章如有细节错误，可在原稿上直接改动。































































































































































































































































































































































































































































































































                        </p>































































































































































































































































































































































































































































































































                        <p style="text-align: left">































































































































































































































































































































































































































































































































                          4.在被审稿件发表之前，请审稿专家勿使用该研究中的资料。































































































































































































































































































































































































































































































































                        </p>































































































































































































































































































































































































































































































































                        <p style="text-align: left">































































































































































































































































































































































































































































































































                          5. 如无时间审阅，请告知并推荐其他专家审阅。































































































































































































































































































































































































































































































































                        </p>































































































































































































































































































































































































































































































































                        <p style="text-align: left">































































































































































































































































































































































































































































































































                          衷心感谢您对本刊工作的大力支持！































































































































































































































































































































































































































































































































                        </p>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col><br /><br /></el-col>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>选题方面：</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.topicValue"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option label="有重要意义" value="有重要意义">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="有一定意义" value="有一定意义">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="无意义" value="无意义"> </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>理论意义：</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.theoryValue"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option































































































































































































































































































































































































































































































































                            label="有重要理论意义"































































































































































































































































































































































































































































































































                            value="有重要理论意义"































































































































































































































































































































































































































































































































                          >































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option































































































































































































































































































































































































































































































































                            label="有一定理论意义 "































































































































































































































































































































































































































































































































                            value="有一定理论意义 "































































































































































































































































































































































































































































































































                          >































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="无理论意义" value="无理论意义">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>应用价值</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.useValue"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option































































































































































































































































































































































































































































































































                            label="有较大应用价值"































































































































































































































































































































































































































































































































                            value="有较大应用价值"































































































































































































































































































































































































































































































































                          >































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option































































































































































































































































































































































































































































































































                            label="有一定应用价值  "































































































































































































































































































































































































































































































































                            value="有一定应用价值  "































































































































































































































































































































































































































































































































                          >































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="无应用价值" value="无应用价值">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col :span="24">































































































































































































































































































































































































































































































































                        <br />































































































































































































































































































































































































































































































































                        <br































































































































































































































































































































































































































































































































                      /></el-col>































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>创新性：</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.creativeValue"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option label="有新成果 " value="有新成果 ">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="有新见解   " value="有新见解   ">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="重复他人工作" value="重复他人工作">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="无新内容" value="无新内容">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>分析方法：</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.analyzeValue"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option label="恰当 " value="恰当 "> </el-option>































































































































































































































































































































































































































































































































                          <el-option































































































































































































































































































































































































































































































































                            label="比较恰当     "































































































































































































































































































































































































































































































































                            value="比较恰当     "































































































































































































































































































































































































































































































































                          >































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="不恰当" value="不恰当"> </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>研究结论：</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.studyValue"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option label="可靠 " value="可靠 "> </el-option>































































































































































































































































































































































































































































































































                          <el-option































































































































































































































































































































































































































































































































                            label="比较可靠      "































































































































































































































































































































































































































































































































                            value="比较可靠      "































































































































































































































































































































































































































































































































                          >































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="不可靠" value="不可靠"> </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col :span="24">































































































































































































































































































































































































































































































































                        <br />































































































































































































































































































































































































































































































































                        <br































































































































































































































































































































































































































































































































                      /></el-col>































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>学术水平：</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.academicValue"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option label="很高 " value="很高 "> </el-option>































































































































































































































































































































































































































































































































                          <el-option label="较高      " value="较高      ">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="一般" value="一般"> </el-option>































































































































































































































































































































































































































































































































                          <el-option label="较低" value="较低"> </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>总体评价：</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.aboveValue"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option label="优" value="优"> </el-option>































































































































































































































































































































































































































































































































                          <el-option label="良" value="良"> </el-option>































































































































































































































































































































































































































































































































                          <el-option label="中" value="中"> </el-option>































































































































































































































































































































































































































































































































                          <el-option label="劣" value="劣"> </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                      <el-col :span="3" class="med"































































































































































































































































































































































































































































































































                        ><label>审稿结论：</label></el-col































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                      <el-col :span="5">































































































































































































































































































































































































































































































































                        <el-select































































































































































































































































































































































































































































































































                          placeholder="请选择"































































































































































































































































































































































































































































































































                          v-model="info.reviewer.manuscriptStatus"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <el-option label="可以发表 " value="success">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="改后发表 " value="fixed_publish">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="改后重审" value="fixed_review">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                          <el-option label="不宜发表" value="refuse">































































































































































































































































































































































































































































































































                          </el-option>































































































































































































































































































































































































































































































































                        </el-select>































































































































































































































































































































































































































































































































                      </el-col>































































































































































































































































































































































































































































































































                      <el-col :span="24">































































































































































































































































































































































































































































































































                        <br />































































































































































































































































































































































































































































































































                        <br































































































































































































































































































































































































































































































































                      /></el-col>































































































































































































































































































































































































































































































































                    </el-row>































































































































































































































































































































































































































































































































                    <el-col :span="24"> &nbsp;</el-col>































































































































































































































































































































































































































































































































                    <p style="text-align: left; margin-left: 10px">































































































































































































































































































































































































































































































































                      具体审稿意见和修改意见:































































































































































































































































































































































































































































































































                    </p>































































































































































































































































































































































































































































































































                    <el-input































































































































































































































































































































































































































































































































                      style="height: 200px"































































































































































































































































































































































































































































































































                      :rows="8"































































































































































































































































































































































































































































































































                      type="textarea"































































































































































































































































































































































































































































































































                      placeholder="请输入具体审稿意见和修改意见："































































































































































































































































































































































































































































































































                      v-model="info.reviewer.auditOpinion"































































































































































































































































































































































































































































































































                      show-word-limit































































































































































































































































































































































































































































































































                    >































































































































































































































































































































































































































































































































                    </el-input>































































































































































































































































































































































































































































































































                    <br />































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                    <p style="text-align: left; margin-left: 10px">































































































































































































































































































































































































































































































































                      给编辑部的意见或建议:































































































































































































































































































































































































































































































































                    </p>































































































































































































































































































































































































































































































































                    <el-input































































































































































































































































































































































































































































































































                      style="height: 200px"































































































































































































































































































































































































































































































































                      :rows="8"































































































































































































































































































































































































































































































































                      type="textarea"































































































































































































































































































































































































































































































































                      placeholder="请输入给编辑部的意见："































































































































































































































































































































































































































































































































                      v-model="info.reviewer.chargeOpinion"































































































































































































































































































































































































































































































































                      show-word-limit































































































































































































































































































































































































































































































































                    >































































































































































































































































































































































































































































































































                    </el-input>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                    <el-col :span="4" :offset="20">































































































































































































































































































































































































































































































































                      <el-button































































































































































































































































































































































































































































































































                        type="primary"































































































































































































































































































































































































































































































































                        @click.native="submit(info.reviewer)"































































































































































































































































































































































































































































































































                        >提交</el-button































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                    </el-col>































































































































































































































































































































































































































































































































                  </el-form>































































































































































































































































































































































































































































































































                </el-col>































































































































































































































































































































































































































































































































              </el-row>































































































































































































































































































































































































































































































































            </div>































































































































































































































































































































































































































































































































          </el-col>































































































































































































































































































































































































































































































































          <el-col v-else>































































































































































































































































































































































































































































































































            <el-divider content-position="center">审稿结果</el-divider>































































































































































































































































































































































































































































































































            <el-descriptions border :column="3">































































































































































































































































































































































































































































































































              <el-descriptions-item label="选题方面">{{































































































































































































































































































































































































































































































































                info.reviewer.topicValue































































































































































































































































































































































































































































































































              }}</el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="理论意义">{{































































































































































































































































































































































































































































































































                info.reviewer.theoryValue































































































































































































































































































































































































































































































































              }}</el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="应用价值">































































































































































































































































































































































































































































































































                <p>{{ info.reviewer.useValue }}</p></el-descriptions-item































































































































































































































































































































































































































































































































              >































































































































































































































































































































































































































































































































              <el-descriptions-item label="创新性">































































































































































































































































































































































































































































































































                {{ info.reviewer.creativeValue }}































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































              <el-descriptions-item label="分析方法">{{































































































































































































































































































































































































































































































































                info.reviewer.analyzeValue































































































































































































































































































































































































































































































































              }}</el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="研究结论">{{































































































































































































































































































































































































































































































































                info.reviewer.studyValue































































































































































































































































































































































































































































































































              }}</el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="学术水平">































































































































































































































































































































































































































































































































                <p>{{ info.reviewer.academicValue }}</p></el-descriptions-item































































































































































































































































































































































































































































































































              >































































































































































































































































































































































































































































































































              <el-descriptions-item label="总体评价">































































































































































































































































































































































































































































































































                {{ info.reviewer.aboveValue }}































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="审稿结论：" :span="3">































































































































































































































































































































































































































































































































                <p v-if="info.reviewer.manuscriptStatus == 'unreviewed'">































































































































































































































































































































































































































































































































                  待审核































































































































































































































































































































































































































































































































                </p>































































































































































































































































































































































































































































































































                <p v-if="info.reviewer.manuscriptStatus == 'success'">通过</p>































































































































































































































































































































































































































































































































                <p v-if="info.reviewer.manuscriptStatus == 'fixed_publish'">































































































































































































































































































































































































































































































































                  改后发表































































































































































































































































































































































































































































































































                </p>































































































































































































































































































































































































































































































































                <p v-if="info.reviewer.manuscriptStatus == 'fixed_review'">































































































































































































































































































































































































































































































































                  改后再审































































































































































































































































































































































































































































































































                </p>































































































































































































































































































































































































































































































































                <p v-if="info.reviewer.manuscriptStatus == 'refuse'">驳回</p>































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="具体审稿意见和修改意见：" :span="3">































































































































































































































































































































































































































































































































                <p>{{ info.reviewer.auditOpinion }}</p>































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































              <el-descriptions-item label="给编辑部的意见或建议：" :span="3">































































































































































































































































































































































































































































































































                <p>{{ info.reviewer.chargeOpinion }}</p>































































































































































































































































































































































































































































































































              </el-descriptions-item>































































































































































































































































































































































































































































































































            </el-descriptions>































































































































































































































































































































































































































































































































          </el-col>































































































































































































































































































































































































































































































































        </div>































































































































































































































































































































































































































































































































      </div>































































































































































































































































































































































































































































































































    </el-row>































































































































































































































































































































































































































































































































  </div>































































































































































































































































































































































































































































































































</template>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































<script>































































































































































































































































































































































































































































































































import {































































































































































































































































































































































































































































































































  getManuscriptsReviewerInfo,































































































































































































































































































































































































































































































































  reviewerAddAuditOpinion,































































































































































































































































































































































































































































































































  reviewerCancelTheAudit,































































































































































































































































































































































































































































































































} from "@/api/data";































































































































































































































































































































































































































































































































export default {































































































































































































































































































































































































































































































































  name: "reviewerDetail",































































































































































































































































































































































































































































































































  components: {},































































































































































































































































































































































































































































































































  data() {































































































































































































































































































































































































































































































































    return {































































































































































































































































































































































































































































































































      id: "",































































































































































































































































































































































































































































































































      contentShow: false,































































































































































































































































































































































































































































































































      options: [































































































































































































































































































































































































































































































































        {































































































































































































































































































































































































































































































































          value: "success",































































































































































































































































































































































































































































































































          label: "通过",































































































































































































































































































































































































































































































































        },































































































































































































































































































































































































































































































































        {































































































































































































































































































































































































































































































































          value: "refuse",































































































































































































































































































































































































































































































































          label: "拒接",































































































































































































































































































































































































































































































































        },































































































































































































































































































































































































































































































































      ],































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      reviewerManuscriptSatus: null,































































































































































































































































































































































































































































































































      userInfo: null,































































































































































































































































































































































































































































































































      manuscriptsFlag: "",































































































































































































































































































































































































































































































































      activeNames: ["4"],































































































































































































































































































































































































































































































































      time: "",































































































































































































































































































































































































































































































































      info: {































































































































































































































































































































































































































































































































        manuscript: {































































































































































































































































          title: "",































































































































































































































































          abstracts: "",































































































































































































































































          manuscriptKeywords: "",































































































































































































































































          deliveryTime: "",































































































































































































































































          content: "",































































































































































































































































          manuscriptId: "",































































































































































































































































        },































































































































































































































































































































































































































































































































        reviewer: {































































































































          topicValue: "",































































































































          theoryValue: "",































































































































          useValue: "",































































































































          creativeValue: "",































































































































          analyzeValue: "",































































































































          studyValue: "",































































































































          academicValue: "",































































































































          aboveValue: "",































































































































          manuscriptStatus: "",































































































































          auditOpinion: "",































































































































          chargeOpinion: "",































































































































          id: "",































































































































        },































































































































































































































































































































































































































































































































      },































































































































































































































































































































































































































































































































    };































































































































































































































































































































































































































































































































  },































































































































































































































































































































































































































































































































  methods: {































































































































































































































































































































































































































































































































    formatDate(date, fmt) {































































































































































































































































































































































































































































































































      if (/(y+)/.test(fmt)) {































































































































































































































































































































































































































































































































        fmt = fmt.replace(































































































































































































































































































































































































































































































































          RegExp.$1,































































































































































































































































































































































































































































































































          (date.getFullYear() + "").substr(4 - RegExp.$1.length)































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































      }































































































































































































































































































































































































































































































































      let o = {































































































































































































































































































































































































































































































































        "M+": date.getMonth() + 1,































































































































































































































































































































































































































































































































        "d+": date.getDate(),































































































































































































































































































































































































































































































































        "h+": date.getHours(),































































































































































































































































































































































































































































































































        "m+": date.getMinutes(),































































































































































































































































































































































































































































































































        "s+": date.getSeconds(),































































































































































































































































































































































































































































































































      };































































































































































































































































































































































































































































































































      for (let k in o) {































































































































































































































































































































































































































































































































        if (new RegExp(`(${k})`).test(fmt)) {































































































































































































































































































































































































































































































































          let str = o[k] + "";































































































































































































































































































































































































































































































































          fmt = fmt.replace(































































































































































































































































































































































































































































































































            RegExp.$1,































































































































































































































































































































































































































































































































            RegExp.$1.length === 1 ? str : this.padLeftZero(str)































































































































































































































































































































































































































































































































          );































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































      }































































































































































































































































































































































































































































































































      return fmt;































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































    // 左边补0函数































































































































































































































































































































































































































































































































    padLeftZero(str) {































































































































































































































































































































































































































































































































      return ("00" + str).substr(str.length);































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































    submit(item) {































































































































































































































































































































































































































































































































      reviewerAddAuditOpinion(item).then((res) => {































































































































































































































































































































































































































































































































        const back = this;































































































































































































































































































































































































































































































































        back.$router.push({ name: "reviewerList" });































































































































































































































































































































































































































































































































        this.fetchInfo();































































































































































































































































































































































































































































































































      });































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































    back() {































































































































































































































































































































































































































































































































      const back = this;































































































































































































































































































































































































































































































































      back.$router.push({ name: "reviewerList" });































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































    fetchInfo() {































































































































































































































































































































































































































































































































      getManuscriptsReviewerInfo({































































































































































































































































































































































































































































































































        reviewerEmail: this.userInfo && this.userInfo.email,































































































































































































































































































































































































































































































































        manuscriptFlag: this.manuscriptsFlag,































































































































































































































































































































































































































































































































      }).then((res) => {































































































































































































































































































































































































































































































































        console.log(res);































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































        const result = res && res.data ? res.data.result : null;































        if (!result || !result.manuscript || !result.reviewer) {































          this.$message({































            message: "未获取到审稿详情，请确认该稿件已分配给当前审稿人",































            type: "warning",































          });































          this.back();
          return;































        }































































        this.info = result;































































































































































































































































































































































































































































































































        if (this.info.manuscript && this.info.manuscript.id) {















          let date = new Date(this.info.manuscript.id / 1000);















          // 时间已在上方按 manuscript.id 存在性计算















        } else {















          this.time = "";















        }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































        this.reviewerManuscriptSatus = this.info.reviewer.manuscriptStatus;































































































































































































































































































































































































































































































































        this.id = this.info.reviewer.id;































































































































































































































































































































































































































































































































      });































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    cancelTheAudit() {































































































































































































































































































































































































































































































































      reviewerCancelTheAudit({































































































































































































































































































































































































































































































































        id: this.id,































































































































































































































































































































































































































































































































      }).then((res) => {































































































































































































































































































































































































































































































































        console.log("kakaka" + res.data.result);































































































































































































































































































































































































































































































































        if (res.data.result == true) {































































































































































































































































































































































































































































































































          this.$message({































































































































































































































































































































































































































































































































            message: "撤销成功",































































































































































































































































































































































































































































































































            type: "sussess",































































































































































































































































































































































































































































































































          });































































































































































































































































































































































































































































































































          const back = this;































































































































































































































































































































































































































































































































          back.$router.push({ name: "reviewerList" });































































































































































































































































































































































































































































































































          this.fetchInfo();































































































































































































































































































































































































































































































































        } else {































































































































































































































































































































































































































































































































          this.$message({































































































































































































































































































































































































































































































































            message: "撤销失败",































































































































































































































































































































































































































































































































            type: "error",































































































































































































































































































































































































































































































































          });































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































      });































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    getPdfBase64(item) {































































































































































































































































































































































































































































































































      return Base64.encode(































































































































































































































































































































































































































































































































        "http://www.exp-linguistics.net/file/" +































































































































































































































































































































































































































































































































          JSON.parse(item.content).mainPdf































































































































































































































































































































































































































































































































      );































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































    getZipUrl(item) {































































































































































































































































































































































































































































































































      return (































































































































































































































































































































































































































































































































        "http://www.exp-linguistics.net/file/" + item.title + item.manuscriptId + ".zip"































































































































































































































































































































































































































































































































      );































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































    downloadZip(fileUrl) {































































































































































































































































































































































































































































































































      window.open(fileUrl);































































































































































































































































































































































































































































































































    },































































































































































































































































































































































































































































































































  },































































































































































































































































































































































































































































































































  mounted() {































































































































































































































































































































































































































































































































    let userInfo = this.$cookie.getCookie("userInfo");































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    // if (userInfo == null || userInfo.type != "审稿人") {































































































































































































































































































































































































































































































































    //   this.$message({































































































































































































































































































































































































































































































































    //     message: "请先登录！",































































































































































































































































































































































































































































































































    //     type: "error",































































































































































































































































































































































































































































































































    //   });































































































































































































































































































































































































































































































































    //   this.$router.push("index");































































































































































































































































































































































































































































































































    // }































































































































































































































































































































































































































































































































    this.userInfo = userInfo;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    this.manuscriptsFlag = this.$route.query.flag;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    this.fetchInfo();































































































































































































































































































































































































































































































































  },































































































































































































































































































































































































































































































































};































































































































































































































































































































































































































































































































</script>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































<style lang="scss" scoped>































































































































































































































































































































































































































































































































.content {































































































































































































































































































































































































































































































































  margin-top: 12px;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  .mydoc {































































































































































































































































































































































































































































































































    border-radius: 4px;































































































































































































































































































































































































































































































































    min-height: 20rem;































































































































































































































































































































































































































































































































    box-shadow: 2px 3px 10px rgb(51, 72, 94);































































































































































































































































































































































































































































































































    text-align: left;































































































































































































































































































































































































































































































































    .mybody {































































































































































































































































































































































































































































































































      //   background: linear-gradient(45deg, #34495e, #41b883);































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      padding: 10px;































































































































































































































































































































































































































































































































      background-color: white;































































































































































































































































































































































































































































































































      overflow: auto;































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































    p {































































































































































































































































































































































































































































































































      color: black;































































































































































































































































































































































































































































































































      text-indent: 30px;































































































































































































































































































































































































































































































































      line-height: 24px;































































































































































































































































































































































































































































































































      padding: 10px;































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































  }































































































































































































































































































































































































































































































































}































































































































































































































































































































































































































































































































.header {































































































































































































































































































































































































































































































































  padding: 10px;































































































































































































































































































































































































































































































































  text-align: left;































































































































































































































































































































































































































































































































  background-color: gainsboro;































































































































































































































































































































































































































































































































  border-top-left-radius: 4px;































































































































































































































































































































































































































































































































  border-top-right-radius: 4px;































































































































































































































































































































































































































































































































  border-bottom: 1px solid gainsboro;































































































































































































































































































































































































































































































































}































































































































































































































































































































































































































































































































button {































































































































































































































































































































































































































































































































  background-color: #004947;































































































































































































































































































































































































































































































































  border: none;































































































































































































































































































































































































































































































































}































































































































































































































































































































































































































































































































button:hover {































































































































































































































































































































































































































































































































  background-color: #004947;































































































































































































































































































































































































































































































































}































































































































































































































































































































































































































































































































button:active {































































































































































































































































































































































































































































































































  background-color: #004947;































































































































































































































































































































































































































































































































}































































































































































































































































































































































































































































































































</style>


































































































































































































































































































































































































































































































































// WEBPACK FOOTER //
// src/view/reviewer/reviewerDetail.vue